module.exports = __webpack_public_path__ + "static/rainforest-720cf9efe89a389670e7340e10dddb98.jpg";